import { NewsType } from 'components/News/types';
import { collection, onSnapshot, query } from 'firebase/firestore';
import { Dispatch, SetStateAction } from 'react';
import { NEWS } from 'utils/config/constants/controllerNames';
import { auth, db } from 'utils/config/firebase';
import { errorLogger } from 'utils/config/firebase/logs';

export const getNewsQuery = (
    setNews: Dispatch<SetStateAction<NewsType[]>>,
    setShownNews: Dispatch<SetStateAction<string>>,
) => {
    try {
        const collectionRef = collection(db, NEWS);
        const q = query(collectionRef);
        onSnapshot(q, (snapshot) => {
            if (snapshot.docs[0]) {
                const filteredData = snapshot.docs.map((doc) => ({
                    ...doc.data(),
                    document_id: doc.id,
                })) as NewsType[];

                const newsForThisUser = filteredData.filter(
                    (item) =>
                        !item.users?.includes(auth?.currentUser?.uid as string) &&
                        new Date(filteredData?.[0]?.created_at?.seconds * 1000) >
                            new Date(auth.currentUser?.metadata.creationTime as string),
                );
                setNews(newsForThisUser);
                setShownNews(newsForThisUser[0]?.document_id || '');
            }
        });
    } catch (error) {
        if (error instanceof Error) {
            errorLogger.critical(error?.message, 'getNewsQuery');
        }
        console.log(error);
    }
};
